up.compiler('[pane-view-sidebar]', function(paneViewSidebar) {
  var $paneViewSidebar = $(paneViewSidebar)

  function setHeight() {
    var clientHeight = document.documentElement.clientHeight;
    var paneViewSidebarTop = $paneViewSidebar.offset().top;
    var paneViewMarginBottom = parseInt($paneViewSidebar.css('marginBottom'));
    $paneViewSidebar.height(clientHeight - paneViewSidebarTop - paneViewMarginBottom);
  }

  // The container size will only be rendered in the next frame
  up.util.task(setHeight);

  $(window).on('resize', setHeight);

  return function() {
    $(window).off('resize', setHeight)
  };

});
